import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI'
import CardUI from '../../../widgets/layout/CardUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './OfftakerCounterpartyPanDetailsPage.css'

const OfftakerCounterpartyPanDetailsPageUI = ({ context, loading, errorList, pan, company, loan, onRefreshClick }) =>
  <SuperUserLoanPageUI
    context={context}
    className='pg_su_pan_details'
    loan={loan}
    backLink={loan ? `/su/loans/${loan.loanId}/project` : '/su/loans'}
    page='project'
    headerText={(company && company.company_name) || 'Company PAN Details'}
    subHeaderText={pan}
    centered={false}
    dimension='w1024'
  >
    <div className='pan_page'>
    <LRTableActionsUI
      location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_large g_m_left_50'><b>PAN Details</b></span>
        </span>
      }
      right={
        null
      }
    />

    {loading && <SpinnerComponentUI />}

    {!loading && errorList && errorList.length > 0 && (
      <CardUI title='Errors'>
        {errorList.map((e, i) => (
          <div key={i} className='g_error_text'>{String(e)}</div>
        ))}
      </CardUI>
    )}

    {!loading && !company && (!errorList || errorList.length === 0) && (
      <CardUI title='No Data'>
        <div className='g_text'>No company details found for the provided PAN.</div>
      </CardUI>
    )}

    {!loading && company && (
      <div className='g_flex_v g_m_top_20'>
        <CardUI className='pan_header_card'>
          <div className='pan_header'>
            <div>
              <div className='pan_title'>{company.company_name}</div>
              <div className='pan_meta'>
                <span className='pan_chip' onClick={() => copy(pan)} title='Click to copy PAN'>PAN: {pan}</span>
                {company.cin && <span className='pan_chip' onClick={() => copy(company.cin)} title='Click to copy CIN'>CIN: {company.cin}</span>}
              </div>
            </div>
            <div className='pan_actions'>
              {statusBadge(company.status)}
              {company.email && (
                <a className='pan_email_link' href={`mailto:${company.email}`}>{company.email}</a>
              )}
            </div>
          </div>
        </CardUI>

        <div className='pan_grid g_m_top_20'>
          <CardUI title='Company Information'>
            <div className='pan_card_body'>
              <div className='pan_row'><span className='lbl'>Date of Incorporation:</span><span className='val'>{company.date_of_incorporation || 'N/A'}</span></div>
              <div className='pan_row'><span className='lbl'>City:</span><span className='val'>{company.city || 'N/A'}</span></div>
              <div className='pan_row'><span className='lbl'>State:</span><span className='val'>{company.state || 'N/A'}</span></div>
              <div className='pan_row'><span className='lbl'>Country:</span><span className='val'>{company.country || 'N/A'}</span></div>
              <div className='pan_row'><span className='lbl'>Pincode:</span><span className='val'>{company.pincode || 'N/A'}</span></div>
              <div className='pan_row'><span className='lbl'>Status:</span><span className='val'>{company.status || 'N/A'}</span></div>
            </div>
          </CardUI>

          <CardUI title='Registered Address'>
            <div className='pan_card_body'>
              <div className='pan_address_box'>
                <div className='pan_address'>{company.address1 || 'N/A'}</div>
                {company.address2 && <div className='pan_address'>{company.address2}</div>}
              </div>
            </div>
          </CardUI>
        </div>

        {company.directorDetail && company.directorDetail.length > 0 && (
          <CardUI title='Directors' className='g_m_top_20'>
            <div className='pan_table_wrapper'>
            <table className='pan_table'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>DIN</th>
                </tr>
              </thead>
              <tbody>
                {company.directorDetail.map((d, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{d.name || 'N/A'}</td>
                    <td><span className='din_code'>{d.din || 'N/A'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </CardUI>
        )}
      </div>
    )}
    </div>
  </SuperUserLoanPageUI>

const Inline = ({ label, children }) => (
  <span className='g_m_right_100'>
    <span className='g_label'>{label}:</span>
    <span className='g_m_left_20'>{children}</span>
  </span>
)

const TwoColRow = ({ label, value }) => (
  <div className='g_flex_h g_flex_between g_m_bottom_10'>
    <span className='g_label'>{label}:</span>
    <span className='g_value'>{value || 'N/A'}</span>
  </div>
)

const statusBadge = (status) => {
  if (!status) return null
  const normalized = String(status).toLowerCase()
  if (normalized === 'active') return <BadgeUI text='Active' type='success' />
  if (normalized === 'inactive') return <BadgeUI text='Inactive' type='error' />
  return <BadgeUI text={String(status)} type='secondary' />
}

const copy = (text) => {
  if (!text) return
  try { navigator.clipboard && navigator.clipboard.writeText(text) } catch(e) {}
}

export default OfftakerCounterpartyPanDetailsPageUI


